module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/subcategories/sports_coaching-994795479405000bb1eb5f2b2eeee3a6.png";